import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SingleDatePicker } from 'react-dates';
import './DateSelector.scss';

const DateSelector = props => {
  return props.isSingleDate ? <SingleDateSelector {...props} /> : <DateRangeSelector {...props} />;
};

const SingleDateSelector = props => {
  const { date, onDateChange } = props;
  const [focused, setFocused] = useState(false);
  return (
    <div className='single-date-selector date-selector'>
      <SingleDatePicker
        noBorder
        placeholder={props.placeholder || 'Select a date'}
        displayFormat={props.displayFormat || 'MMMM Do, YYYY'}
        date={date}
        onDateChange={onDateChange}
        focused={focused}
        onFocusChange={({ focused }) => setFocused(focused)}
        id='date-picker'
      />
    </div>
  );
};

const DateRangeSelector = props => {
  return <div>Requires Implementation</div>;
};

DateSelector.propTypes = {
  isSingleDate: PropTypes.bool,
  onDateChange: PropTypes.func.isRequired,
  displayFormat: PropTypes.string
};

SingleDateSelector.propTypes = {
  date: PropTypes.object,
  placeholder: PropTypes.string
};

DateRangeSelector.propTypes = {
  startDatePlaceholderText: PropTypes.string,
  endDatePlaceholderText: PropTypes.string
};

export default DateSelector;
